// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"59":"453df494","161":"0604f201","340":"9660cbbc","613":"aef3c3e6","653":"711d285d","670":"658aec76","737":"48f992cc","765":"80bbca71","771":"41329174","941":"95ffce15","959":"6001d1c0"}[chunkId] + ".chunk.js";
};